import { importProvidersFrom, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxsModule } from '@ngxs/store';
import { PoolListComponent } from '../lib/components/pool-list/pool-list.component';
import { PoolsComponent } from '../pools.component';
import { PoolsState } from '../state/pools';
import { PoolsGuard } from './guards/pools.guard';

const routes: Routes = [
  {
    path: '',
    component: PoolsComponent,
    children: [
      {
        path: 'newpools',
        component: PoolListComponent,
        canActivate: [PoolsGuard],
        providers: [importProvidersFrom(NgxsModule.forFeature([PoolsState]))]
      },
      {
        path: 'newpools/:id',
        loadChildren: () =>
          import('../pool/pool.module').then(m => m.PoolModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PoolsRoutingModule {}
